module.exports = __webpack_public_path__ + "img/signal_wifi_statusbar_not_connected_26x24px.82a0e1b0.svg";